import { WorkerTabs } from '@/util/axios/types';

export enum GAEvent {
  Signup = 'Signup',
  FirstLogin = 'FirstLogin',
  BillingSetup = 'BillingSetup',
  SetPaymentMethod = 'SetPaymentMethod',
  Login = 'Login',
  TimesheetApprove = 'TimesheetApprove',
  TimesheetReject = 'TimesheetReject',
  TimesheetUnapprove = 'TimesheetUnapprove',
  StepOneGig = 'StepOneGig',
  StepTwoGig = 'StepTwoGig',
  StepThreeGig = 'StepThreeGig',
  StepFourGig = 'StepFourGig',
  StepFiveGig = 'StepFiveGig',
  StepOneLta = 'StepOneLta',
  StepTwoLta = 'StepTwoLta',
  StepThreeLta = 'StepThreeLta',
  StepFourLta = 'StepFourLta',
  StepFiveLta = 'StepFiveLta',
  TimeStepOneGig = 'TimeStepOneGig',
  TimeStepTwoGig = 'TimeStepTwoGig',
  TimeStepThreeGig = 'TimeStepThreeGig',
  TimeStepFourGig = 'TimeStepFourGig',
  TimeStepFiveGig = 'TimeStepFiveGig',
  TimeStepOneLta = 'TimeStepOneLta',
  TimeStepTwoLta = 'TimeStepTwoLta',
  TimeStepThreeLta = 'TimeStepThreeLta',
  TimeStepFourLta = 'TimeStepFourLta',
  TimeStepFiveLta = 'TimeStepFiveLta',
  WorkerListSearch = 'WorkerListSearch',
  OrderCreateHireWorker = 'OrderCreateHireWorker',
  OrderCreateInviteWorker = 'OrderCreateInviteWorker',
  EditJobRates = 'EditJobRates',
  JobHireWorker = 'JobHireWorker',
  JobInviteWorker = 'JobInviteWorker',
}

export const eventMap = {
  [GAEvent.Signup]: {
    category: 'User',
    action: 'Customer Signup',
    label: 'Customer Signup',
  },
  [GAEvent.FirstLogin]: {
    category: 'User',
    action: 'First Login',
    label: 'First Login',
  },
  [GAEvent.BillingSetup]: {
    category: 'User',
    action: 'Setup Billing',
    label: 'Setup Billing',
  },
  [GAEvent.SetPaymentMethod]: {
    category: 'User',
    action: 'Setup Payment Method',
    label: 'Setup Payment Method',
  },
  [GAEvent.Login]: {
    category: 'User',
    action: 'Customer Login',
    label: 'Customer Login',
  },
  [GAEvent.TimesheetApprove]: {
    category: 'Timesheet',
    action: 'Approve Timesheet',
    label: 'Approve Timesheet',
  },
  [GAEvent.TimesheetReject]: {
    category: 'Timesheet',
    action: 'Reject Timesheet',
    label: 'Reject Timesheet',
  },
  [GAEvent.TimesheetUnapprove]: {
    category: 'Timesheet',
    action: 'Unapprove Timesheet',
    label: 'Unapprove Timesheet',
  },
  [GAEvent.StepOneGig]: {
    category: 'Order Create',
    action: 'Step 1 Gig',
    label: 'Skill Selection',
  },
  [GAEvent.StepTwoGig]: {
    category: 'Order Create',
    action: 'Step 2 Gig',
    label: 'Schedule',
  },
  [GAEvent.StepThreeGig]: {
    category: 'Order Create',
    action: 'Step 3 Gig',
    label: 'Staffing',
  },
  [GAEvent.StepFourGig]: {
    category: 'Order Create',
    action: 'Step 4 Gig',
    label: 'Instructions',
  },
  [GAEvent.StepFiveGig]: {
    category: 'Order Create',
    action: 'Step 5 Gig',
    label: 'Submission',
  },
  [GAEvent.StepOneLta]: {
    category: 'Order Create',
    action: 'Step 1 LTA',
    label: 'Skill Selection',
  },
  [GAEvent.StepTwoLta]: {
    category: 'Order Create',
    action: 'Step 2 LTA',
    label: 'Schedule',
  },
  [GAEvent.StepThreeLta]: {
    category: 'Order Create',
    action: 'Step 3 LTA',
    label: 'Staffing',
  },
  [GAEvent.StepFourLta]: {
    category: 'Order Create',
    action: 'Step 4 LTA',
    label: 'Instruction',
  },
  [GAEvent.StepFiveLta]: {
    category: 'Order Create',
    action: 'Step 5 LTA',
    label: 'Submission',
  },
  [GAEvent.TimeStepOneGig]: {
    category: 'Order Create',
    action: 'Time Step 1 Gig',
    label: 'Skill Selection',
  },
  [GAEvent.TimeStepTwoGig]: {
    category: 'Order Create',
    action: 'Time Step 2 Gig',
    label: 'Schedule',
  },
  [GAEvent.TimeStepThreeGig]: {
    category: 'Order Create',
    action: 'Time Step 3 Gig',
    label: 'Staffing',
  },
  [GAEvent.TimeStepFourGig]: {
    category: 'Order Create',
    action: 'Time Step 4 Gig',
    label: 'Instructions',
  },
  [GAEvent.TimeStepFiveGig]: {
    category: 'Order Create',
    action: 'Time Step 5 Gig',
    label: 'Submission',
  },
  [GAEvent.TimeStepOneLta]: {
    category: 'Order Create',
    action: 'Time Step 1 LTA',
    label: 'Skill Selection',
  },
  [GAEvent.TimeStepTwoLta]: {
    category: 'Order Create',
    action: 'Time Step 2 LTA',
    label: 'Schedule',
  },
  [GAEvent.TimeStepThreeLta]: {
    category: 'Order Create',
    action: 'Time Step 3 LTA',
    label: 'Staffing',
  },
  [GAEvent.TimeStepFourLta]: {
    category: 'Order Create',
    action: 'Time Step 4 LTA',
    label: 'Instructions',
  },
  [GAEvent.TimeStepFiveLta]: {
    category: 'Order Create',
    action: 'Time Step 5 LTA',
    label: 'Submission',
  },
  [WorkerTabs.All]: {
    category: 'Worker Tabs',
    action: 'All Tab',
    label: 'All Tab',
  },
  [WorkerTabs.Favorites]: {
    category: 'Worker Tabs',
    action: 'Favorites Tab',
    label: 'Favorites Tab',
  },
  [WorkerTabs.GravyTrained]: {
    category: 'Worker Tabs',
    action: 'Gravy Trained Tab',
    label: 'Gravy Trained Tab',
  },
  [WorkerTabs.HighlyRated]: {
    category: 'Worker Tabs',
    action: 'Highly Rated Tab',
    label: 'Highly Rated Tab',
  },
  [WorkerTabs.PastWorkers]: {
    category: 'Worker Tabs',
    action: 'Past Worker Tab',
    label: 'Past Worker Tab',
  },
  [GAEvent.WorkerListSearch]: {
    category: 'Worker List',
    action: 'Worker List Search',
    label: 'Worker List Search',
  },
  [GAEvent.OrderCreateHireWorker]: {
    category: 'Order Create',
    action: 'Order Create Hire Worker',
    label: 'Order Create Hire Worker',
  },
  [GAEvent.OrderCreateInviteWorker]: {
    category: 'Order Create',
    action: 'Order Create Invite Worker',
    label: 'Order Create Invite Worker',
  },
  [GAEvent.EditJobRates]: {
    category: 'Edit Job',
    action: 'Edit Job Rates',
    label: 'Edit Job Rates',
  },
  [GAEvent.JobHireWorker]: {
    category: 'Job Update',
    action: 'Job Hire Worker',
    label: 'Job Hire Worker',
  },
  [GAEvent.JobInviteWorker]: {
    category: 'Job Update',
    action: 'Job Invite Worker',
    label: 'Job Invite Worker',
  },
};
